const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  rating ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jye/v1frontend/jyorder/rating', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
